// extracted by mini-css-extract-plugin
module.exports = {"Successpage":"SuccessPage_Successpage__viSmM"};